import React, { memo } from 'react';
import styles from './FloorsTable.module.scss';
import FloorTableRows from '../FloorTableRows/FloorTableRows';
import { Empty } from 'antd';

const FloorsTable = ({ data, header, clickHighlighted, rowOnClick }) => {
  return (
    <div className={styles.floorsTable}>
      <div className={styles.header}>
        <div>{header[0]}</div>
        <div className={styles.floorData}>
          {header.slice(1).map((headerItem, index) => (
            <div
              key={`${headerItem} ${index}`}
              className={index < 2 ? styles.blockHighlight : null}
              style={{ textAlign: index === 1 ? 'center' : 'left' }}
            >
              {headerItem}
            </div>
          ))}
        </div>
      </div>
      {data.map((floor) => (
        <div className={styles.floor} key={floor.floor}>
          <div className={styles.floorNum}>
            <div className={styles.background} />
            <div className={styles.floorNumCell}>{floor.floor}</div>
          </div>
          <div className={styles.floorData}>
            <FloorTableRows
              rowOnClick={rowOnClick}
              rowData={floor.offices}
              clickHighlighted={clickHighlighted}
            />
          </div>
        </div>
      ))}
      {!data.length && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
    </div>
  );
};

export default memo(FloorsTable);
